import reactorFloorFoundationUrl from "./generated/reactor-floor-foundation.png";
import railButtonFrameUrl from "./generated/rail-button-frame.png";
import topHudChipFrameUrl from "./generated/top-hud-chip-frame.png";
import utilityIconFrameUrl from "./generated/utility-icon-frame.png";
import collectorTrayFrameUrl from "./generated/collector-tray-frame.png";
import forgePanelFrameUrl from "./generated/forge-panel-frame.png";
import coreSpritesUrl from "./generated/core-sprites.png";
import supplyCrateClosedUrl from "./generated/crates/supply-crate-closed.png";
import supplyCrateOpenUrl from "./generated/crates/supply-crate-open.png";
import supplyCrateOpenJackpotUrl from "./generated/crates/supply-crate-open-jackpot.png";
import supplyCrateOpenNeonUrl from "./generated/crates/supply-crate-open-neon.png";
import supplyCrateJackpotUrl from "./generated/crates/supply-crate-jackpot.png";
import cosmeticCoreCheckerCoreUrl from "./generated/cosmetics/core-checker-core.png";
import luckySparkUrl from "./generated/events/lucky-spark.png";
import cosmeticCoreDiceCoreUrl from "./generated/cosmetics/core-dice-core.png";
import cosmeticCorePrismCoreUrl from "./generated/cosmetics/core-prism-core.png";
import gameIconAutoLaunchUrl from "./generated/game-icons/auto-launch.png";
import gameIconChargeBonusUrl from "./generated/game-icons/charge-bonus.png";
import gameIconCollectorAmpUrl from "./generated/game-icons/collector-amp.png";
import gameIconCoreValueUrl from "./generated/game-icons/core-value.png";
import gameIconCriticalDischargeUrl from "./generated/game-icons/critical-discharge.png";
import gameIconExtraShellUrl from "./generated/game-icons/extra-shell.png";
import gameIconForgeUrl from "./generated/game-icons/forge.png";
import gameIconGateCountUrl from "./generated/game-icons/gate-count.png";
import gameIconGateWidthUrl from "./generated/game-icons/gate-width.png";
import gameIconMaxCoresUrl from "./generated/game-icons/max-cores.png";
import gameIconOfflineReactorUrl from "./generated/game-icons/offline-reactor.png";
import gameIconOverchargedCoreUrl from "./generated/game-icons/overcharged-core.png";
import gameIconOverdriveUrl from "./generated/game-icons/overdrive.png";
import gameIconPolaritySyncUrl from "./generated/game-icons/polarity-sync.png";
import gameIconProfilePlayerUrl from "./generated/game-icons/profile-player.png";
import gameIconReactorStormUrl from "./generated/game-icons/reactor-storm.png";
import gameIconShellLensUrl from "./generated/game-icons/shell-lens.png";
import gameIconShellSpeedUrl from "./generated/game-icons/shell-speed.png";
import gameIconSupplyCratesUrl from "./generated/game-icons/supply-crates.png";

export interface AssetManifestEntry {
  readonly id: string;
  readonly path: string;
  readonly url: string;
  readonly width: number;
  readonly height: number;
  readonly format: "png" | "webp" | "jpg";
  readonly usage: string;
  readonly source: string;
}

const gameIconSource =
  "Generated with built-in image tool as a simple Orbit gameplay icon sheet using the Forge-panel screenshot as style reference, then chroma-key processed, cropped, and centered as transparent PNGs; no text, logo, or copied asset pack art.";
const crateAssetSource =
  "Generated with built-in image tool from identity.md Supply Crate prompts on chroma key, processed to transparent PNG with local chroma-key removal, then resized to 512px; no text, logo, money, or copied asset pack art.";
const crateCosmeticSource =
  "Generated with built-in image tool from identity.md crate cosmetic preview prompts on chroma key, processed to transparent PNG with local chroma-key removal, then resized to 512px; no text, logo, or gameplay-critical geometry.";
const eventAssetSource =
  "Generated with built-in image tool from identity.md timed-event prompts on chroma key, processed to transparent PNG with local chroma-key removal, then cropped and resized to 512px; no text, logo, or gameplay-critical geometry.";

function createGameIconEntry(id: string, fileName: string, url: string, usage: string): AssetManifestEntry {
  return {
    id,
    path: `src/assets/generated/game-icons/${fileName}`,
    url,
    width: 256,
    height: 256,
    format: "png",
    usage,
    source: gameIconSource
  };
}

export const assetManifest = {
  reactorFloorFoundation: {
    id: "reactor-floor-foundation",
    path: "src/assets/generated/reactor-floor-foundation.png",
    url: reactorFloorFoundationUrl,
    width: 1672,
    height: 941,
    format: "png",
    usage: "Subtle fixed-frame reactor floor backdrop behind code-native HUD and arena geometry.",
    source:
      "Generated with built-in image tool from identity.md Kenney-inspired clean modular arcade reactor-floor prompt; no text or logo."
  },
  railButtonFrame: {
    id: "rail-button-frame",
    path: "src/assets/generated/rail-button-frame.png",
    url: railButtonFrameUrl,
    width: 1448,
    height: 1086,
    format: "png",
    usage: "Transparent bitmap backing for left and right HUD rail buttons; code-native icons and text render above it.",
    source:
      "Generated with built-in image tool as a clean modular arcade UI button frame on chroma key, then processed to RGBA with local chroma-key removal; no text, logo, or icons."
  },
  topHudChipFrame: {
    id: "top-hud-chip-frame",
    path: "src/assets/generated/top-hud-chip-frame.png",
    url: topHudChipFrameUrl,
    width: 1774,
    height: 887,
    format: "png",
    usage: "Transparent bitmap backing for top HUD chips and metric readouts; code-native text and icons render above it.",
    source:
      "Generated with built-in image tool as a clean modular arcade top HUD chip on chroma key, then processed to RGBA with local chroma-key removal; no text, logo, or icons."
  },
  utilityIconFrame: {
    id: "utility-icon-frame",
    path: "src/assets/generated/utility-icon-frame.png",
    url: utilityIconFrameUrl,
    width: 1254,
    height: 1254,
    format: "png",
    usage: "Transparent bitmap backing for compact top-right utility icon buttons; code-native icons render above it.",
    source:
      "Generated with built-in image tool as a clean modular arcade square utility button on chroma key, then processed to RGBA with local chroma-key removal; no text, logo, or icons."
  },
  collectorTrayFrame: {
    id: "collector-tray-frame",
    path: "src/assets/generated/collector-tray-frame.png",
    url: collectorTrayFrameUrl,
    width: 2172,
    height: 724,
    format: "png",
    usage: "Transparent bitmap backing for the bottom collector lane tray; code-native lane labels render above it.",
    source:
      "Generated with built-in image tool as a clean modular arcade five-lane collector tray on chroma key, then processed to RGBA with local chroma-key removal; no text, logo, or icons."
  },
  forgePanelFrame: {
    id: "forge-panel-frame",
    path: "src/assets/generated/forge-panel-frame.png",
    url: forgePanelFrameUrl,
    width: 1182,
    height: 1331,
    format: "png",
    usage: "Transparent bitmap backing for the Forge upgrades panel; code-native upgrade rows, prices, icons, and buttons render above it.",
    source:
      "Generated with built-in image tool from identity.md clean modular arcade reactor UI panel prompt on chroma key, then processed to RGBA with local chroma-key removal; no text, logo, icons, or copied asset pack art."
  },
  coreSprites: {
    id: "core-sprites",
    path: "src/assets/generated/core-sprites.png",
    url: coreSpritesUrl,
    width: 2172,
    height: 724,
    format: "png",
    usage: "Transparent sprite sheet for visual-only cyan, pink, lime, and gold launched core rendering; gameplay collision remains code-native circles.",
    source:
      "Generated with built-in image tool as Orbit core sprites on chroma key, processed to RGBA with local chroma-key removal, then composited from green-key and magenta-key passes to preserve all core colors; no text, logo, or copied asset pack art."
  },
  supplyCrateClosed: {
    id: "supply-crate-closed",
    path: "src/assets/generated/crates/supply-crate-closed.png",
    url: supplyCrateClosedUrl,
    width: 512,
    height: 512,
    format: "png",
    usage: "Closed Supply Crate art for the crate panel and unrevealed modal state.",
    source: crateAssetSource
  },
  supplyCrateOpen: {
    id: "supply-crate-open",
    path: "src/assets/generated/crates/supply-crate-open.png",
    url: supplyCrateOpenUrl,
    width: 512,
    height: 512,
    format: "png",
    usage: "Opened standard Supply Crate art for free, Mini Supply, and normal revealed modal states.",
    source: crateAssetSource
  },
  supplyCrateOpenNeon: {
    id: "supply-crate-open-neon",
    path: "src/assets/generated/crates/supply-crate-open-neon.png",
    url: supplyCrateOpenNeonUrl,
    width: 512,
    height: 512,
    format: "png",
    usage: "Opened Neon Cache crate art for revealed modal states.",
    source: crateAssetSource
  },
  supplyCrateOpenJackpot: {
    id: "supply-crate-open-jackpot",
    path: "src/assets/generated/crates/supply-crate-open-jackpot.png",
    url: supplyCrateOpenJackpotUrl,
    width: 512,
    height: 512,
    format: "png",
    usage: "Opened Jackpot Vault crate art for jackpot crate and jackpot result modal states.",
    source: crateAssetSource
  },
  supplyCrateJackpot: {
    id: "supply-crate-jackpot",
    path: "src/assets/generated/crates/supply-crate-jackpot.png",
    url: supplyCrateJackpotUrl,
    width: 512,
    height: 512,
    format: "png",
    usage: "Jackpot Vault crate art for paid jackpot crate cards and jackpot reveal states.",
    source: crateAssetSource
  },
  cosmeticCoreDiceCore: {
    id: "cosmetic-core-dice-core",
    path: "src/assets/generated/cosmetics/core-dice-core.png",
    url: cosmeticCoreDiceCoreUrl,
    width: 512,
    height: 512,
    format: "png",
    usage: "Crate-only Dice Core pattern preview for reveal and later cosmetic UI.",
    source: crateCosmeticSource
  },
  cosmeticCorePrismCore: {
    id: "cosmetic-core-prism-core",
    path: "src/assets/generated/cosmetics/core-prism-core.png",
    url: cosmeticCorePrismCoreUrl,
    width: 512,
    height: 512,
    format: "png",
    usage: "Crate-only Prism Core pattern preview for reveal and later cosmetic UI.",
    source: crateCosmeticSource
  },
  cosmeticCoreCheckerCore: {
    id: "cosmetic-core-checker-core",
    path: "src/assets/generated/cosmetics/core-checker-core.png",
    url: cosmeticCoreCheckerCoreUrl,
    width: 512,
    height: 512,
    format: "png",
    usage: "Crate-only Checker Core pattern preview for reveal and later cosmetic UI.",
    source: crateCosmeticSource
  },
  luckySpark: {
    id: "lucky-spark",
    path: "src/assets/generated/events/lucky-spark.png",
    url: luckySparkUrl,
    width: 512,
    height: 512,
    format: "png",
    usage: "Clickable Lucky Spark timed reward collectible rendered over visible arena space; gameplay click bounds remain code-native.",
    source: eventAssetSource
  },
  gameIconProfilePlayer: createGameIconEntry(
    "game-icon-profile-player",
    "profile-player.png",
    gameIconProfilePlayerUrl,
    "Single-hue generated gameplay icon for the top-left profile/player HUD chip."
  ),
  gameIconForge: createGameIconEntry(
    "game-icon-forge",
    "forge.png",
    gameIconForgeUrl,
    "Single-hue generated gameplay icon for Forge rail and panel entry points."
  ),
  gameIconAutoLaunch: createGameIconEntry(
    "game-icon-auto-launch",
    "auto-launch.png",
    gameIconAutoLaunchUrl,
    "Single-hue generated gameplay icon for Auto Launch rail controls."
  ),
  gameIconSupplyCrates: createGameIconEntry(
    "game-icon-supply-crates",
    "supply-crates.png",
    gameIconSupplyCratesUrl,
    "Single-hue generated gameplay icon for Supply Crates rail controls."
  ),
  gameIconOverdrive: createGameIconEntry(
    "game-icon-overdrive",
    "overdrive.png",
    gameIconOverdriveUrl,
    "Single-hue generated gameplay icon for Overdrive event controls."
  ),
  gameIconReactorStorm: createGameIconEntry(
    "game-icon-reactor-storm",
    "reactor-storm.png",
    gameIconReactorStormUrl,
    "Single-hue generated gameplay icon for Reactor Storm event controls."
  ),
  gameIconMaxCores: createGameIconEntry(
    "game-icon-max-cores",
    "max-cores.png",
    gameIconMaxCoresUrl,
    "Single-hue generated Forge upgrade icon for Max Cores."
  ),
  gameIconCoreValue: createGameIconEntry(
    "game-icon-core-value",
    "core-value.png",
    gameIconCoreValueUrl,
    "Single-hue generated Forge upgrade icon for Value."
  ),
  gameIconChargeBonus: createGameIconEntry(
    "game-icon-charge-bonus",
    "charge-bonus.png",
    gameIconChargeBonusUrl,
    "Single-hue generated Forge upgrade icon for Bounce Reward."
  ),
  gameIconShellSpeed: createGameIconEntry(
    "game-icon-shell-speed",
    "shell-speed.png",
    gameIconShellSpeedUrl,
    "Single-hue generated Forge upgrade icon for Shell Speed."
  ),
  gameIconGateWidth: createGameIconEntry(
    "game-icon-gate-width",
    "gate-width.png",
    gameIconGateWidthUrl,
    "Single-hue generated Forge upgrade icon for Gate Width."
  ),
  gameIconGateCount: createGameIconEntry(
    "game-icon-gate-count",
    "gate-count.png",
    gameIconGateCountUrl,
    "Single-hue generated Forge upgrade icon for Gates."
  ),
  gameIconExtraShell: createGameIconEntry(
    "game-icon-extra-shell",
    "extra-shell.png",
    gameIconExtraShellUrl,
    "Single-hue generated Forge upgrade icon for Shells."
  ),
  gameIconCollectorAmp: createGameIconEntry(
    "game-icon-collector-amp",
    "collector-amp.png",
    gameIconCollectorAmpUrl,
    "Single-hue generated Forge upgrade icon for Collector Amp."
  ),
  gameIconOverchargedCore: createGameIconEntry(
    "game-icon-overcharged-core",
    "overcharged-core.png",
    gameIconOverchargedCoreUrl,
    "Single-hue generated Forge upgrade icon for Overcharged Cores."
  ),
  gameIconPolaritySync: createGameIconEntry(
    "game-icon-polarity-sync",
    "polarity-sync.png",
    gameIconPolaritySyncUrl,
    "Single-hue generated Forge upgrade icon for Polarity Sync."
  ),
  gameIconCriticalDischarge: createGameIconEntry(
    "game-icon-critical-discharge",
    "critical-discharge.png",
    gameIconCriticalDischargeUrl,
    "Single-hue generated Forge upgrade icon for Critical Discharge."
  ),
  gameIconOfflineReactor: createGameIconEntry(
    "game-icon-offline-reactor",
    "offline-reactor.png",
    gameIconOfflineReactorUrl,
    "Single-hue generated Forge upgrade icon for Offline Reactor."
  ),
  gameIconShellLens: createGameIconEntry(
    "game-icon-shell-lens",
    "shell-lens.png",
    gameIconShellLensUrl,
    "Single-hue generated Forge upgrade icon for Shell Lens."
  )
} as const satisfies Record<string, AssetManifestEntry>;

export type AssetManifestKey = keyof typeof assetManifest;
